@let memberStatusValue = memberStatus();

<rt-dialog-body variant="white">
  <form [formGroup]="form" padding>
    <tlc-edit-member-status
      [currentStatus]="memberStatusValue!"
      (actionClicked)="onStatusActionClicked($event)"
      margin-bottom-medium
    />

    <div class="multi-fields">
      <rt-form-field>
        <rt-label>{{
          'tlc.members.edit_member.account_tab.section.data.first_name' | translate
        }}</rt-label>
        <rt-input rtProtectedControl formControlName="firstName" />
      </rt-form-field>
      <rt-form-field>
        <rt-label>{{
          'tlc.members.edit_member.account_tab.section.data.last_name' | translate
        }}</rt-label>
        <rt-input rtProtectedControl formControlName="lastName" />
      </rt-form-field>
    </div>
    <div class="email-section section">
      <rt-form-field>
        <rt-label
          >{{ 'tlc.members.edit_member.account_tab.section.email.heading' | translate }}
        </rt-label>
        <rt-input rtProtectedControl formControlName="email" />
        @if (memberVerified()) {
          <rt-button class="form-button" (click)="changeEmailClicked()">
            <rt-icon name="mail-outline" />
            <div>{{ 'tlc.members.edit_member.account_tab.section.email.button' | translate }}</div>
          </rt-button>
        }
      </rt-form-field>
    </div>
    @if (memberStatusValue !== TeamMemberStatus.Deactivated) {
      <div class="avatar-section section">
        <rt-heading>{{
          'tlc.members.edit_member.account_tab.section.avatar.heading' | translate
        }}</rt-heading>
        <tlc-avatar-input (avatarChanged)="cacheAvatarImg($event)" />
      </div>
    }

    @if (showDeactivate()) {
      <rt-divider margin-bottom-small />
      @if (memberStatusValue !== TeamMemberStatus.Deactivated) {
        <ng-template [ngTemplateOutlet]="deactivateUser" />
      }

      @if (memberStatusValue === TeamMemberStatus.Deactivated) {
        <ng-template [ngTemplateOutlet]="deleteUser" />
      }
    }
  </form>
</rt-dialog-body>
<rt-dialog-footer variant="white">
  <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button
    class="form-button"
    [disabled]="!form.dirty"
    (click)="submit()"
    [loading]="pending()"
    variant="primary"
    >{{ 'tlc.common.save' | translate }}</rt-button
  >
</rt-dialog-footer>

<ng-template #deactivateUser>
  <div class="deactivate-section section">
    <rt-heading>{{
      'tlc.members.edit_member.account_tab.section.deactivation.heading' | translate
    }}</rt-heading>
    <span>{{
      'tlc.members.edit_member.account_tab.section.deactivation.description' | translate
    }}</span>
    <rt-button variant="outline" class="form-button" (click)="deactivateUserClicked()">
      <rt-icon name="member-deactivate" />
      <span>
        {{ 'tlc.members.edit_member.account_tab.section.deactivation.button' | translate }}</span
      >
    </rt-button>
  </div>
</ng-template>

<ng-template #deleteUser>
  <div class="delete-section section">
    <rt-heading>{{
      'tlc.members.edit_member.account_tab.section.deletion.heading' | translate
    }}</rt-heading>
    <span>{{
      'tlc.members.edit_member.account_tab.section.deletion.description' | translate
    }}</span>
    <rt-button class="form-button" (click)="deleteUserClicked()">
      <rt-icon name="delete-outline" />
      <div>
        {{ 'tlc.members.edit_member.account_tab.section.deletion.button' | translate }}
      </div>
    </rt-button>
  </div>
</ng-template>
